/* This example requires Tailwind CSS v2.0+ */

import { Switch } from "@headlessui/react";
import classNames from "classnames";
import React, { ReactNode } from "react";

export interface ToggleProps {
  checked?: boolean;
  onChange: (b: boolean) => void;
  label?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  value?: string;
  className?: string;
  error?: string;
}

export function Toggle({
  checked,
  value: _value,
  onChange,
  label,
  description,
  disabled,
  error: _error,
  ...props
}: ToggleProps) {
  return (
    <Switch.Group as={React.Fragment}>
      <div className={classNames("flex items-start space-x-3", props.className)}>
        <Switch
          checked={checked === undefined ? false : checked}
          onChange={(val) => {
            onChange(val);
          }}
          className={classNames(
            "relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500",
            {
              "bg-purple-600": checked,
              "bg-muted": !checked,
              "cursor-not-allowed": disabled,
            },
          )}
        >
          <span className="sr-only">Use setting</span>
          <span
            aria-hidden="true"
            className={classNames(
              "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200",
              {
                "translate-x-5": checked,
                "translate-x-0": !checked,
              },
            )}
          />
        </Switch>
        {(label || description) && (
          <div className="text-sm">
            <Switch.Label className="font-medium text-foreground">{label}</Switch.Label>
            {description && <p className="text-muted-foreground">{description}</p>}
          </div>
        )}
      </div>
    </Switch.Group>
  );
}
